__turbopack_context__.v({
  "CTA": "HB5Z3q_CTA",
  "FAB": "HB5Z3q_FAB",
  "btn": "HB5Z3q_btn",
  "contained": "HB5Z3q_contained",
  "danger": "HB5Z3q_danger",
  "hug": "HB5Z3q_hug",
  "icon": "HB5Z3q_icon",
  "outlined": "HB5Z3q_outlined",
  "outlinedDisabled": "HB5Z3q_outlinedDisabled",
  "primary": "HB5Z3q_primary",
  "raised": "HB5Z3q_raised",
  "secondaryCTA": "HB5Z3q_secondaryCTA",
  "small": "HB5Z3q_small",
  "specialSmallSidePadding": "HB5Z3q_specialSmallSidePadding",
  "startIcon": "HB5Z3q_startIcon",
  "success": "HB5Z3q_success",
  "text": "HB5Z3q_text",
  "textNoHover": "HB5Z3q_textNoHover",
  "underlined": "HB5Z3q_underlined",
  "uppercase": "HB5Z3q_uppercase",
  "warning": "HB5Z3q_warning",
});
